import { Button } from "@mui/material";
import CatalogueIconOutline from "img/icones/icons-outline-app-launcher.svg";
import React, { lazy, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { catalogueToggleVersion } from "redux/actions/global";

const CatalogueV1 = lazy(() => import("./catalogue/Catalogue"));
const CatalogueV1ServiceDetails = lazy(() => import("./catalogue/CatalogueServiceDetails"));
const CatalogueV2 = lazy(() => import("./catalogueV2/Catalogue"));
const CatalogueV2ServiceDetails = lazy(() => import("./catalogueV2/CatalogueServiceDetails"));

type CatalogueRouteProps = any;
export function CatalogueRoute(props: CatalogueRouteProps) {
  const catalogueVersion = useSelector((state: any) => parseInt(state.global.data.catalogueVersion || 1));

  const CatalogueComponent = useMemo(() => (catalogueVersion === 2 ? CatalogueV2 : CatalogueV1), [catalogueVersion]);

  return (
    <>
      <CatalogueVersionToggle />
      <CatalogueComponent {...props} />
    </>
  );
}

type CatalogueDetailsRouteProps = any;
export function CatalogueDetailsRoute(props: CatalogueDetailsRouteProps) {
  const catalogueVersion = useSelector((state: any) => parseInt(state.global.data.catalogueVersion || 1));

  const CatalogueDetailsComponent = useMemo(
    () => (catalogueVersion === 2 ? CatalogueV2ServiceDetails : CatalogueV1ServiceDetails),
    [catalogueVersion]
  );

  return (
    <>
      <CatalogueVersionToggle />
      <CatalogueDetailsComponent {...props} />
    </>
  );
}

export function CatalogueVersionToggle({ style, force }: { style?: React.CSSProperties; force?: boolean }) {
  const dispatch = useDispatch();
  const catalogueVersion = useSelector((state: any) => parseInt(state.global.data.catalogueVersion || 1));
  const catalogueVersionToggle = useSelector((state: any) => state.global.data.catalogueVersionToggle);
  const isSuperUser = useSelector((state: any) => state.global.data.loginUser)?.isSuperUser;

  const toggleVersion = useCallback(() => {
    const newVersion = catalogueVersion !== 2 ? 2 : 1;
    dispatch(catalogueToggleVersion(newVersion));
  }, [catalogueVersion, dispatch]);

  const componentStyle = useMemo(() => {
    const baseStyle: React.CSSProperties = { position: "fixed", top: "5px", right: "80px", zIndex: 101 };
    if (!style) return baseStyle;
    return { ...baseStyle, ...style };
  }, [style]);

  const isNewCatalogue = catalogueVersion === 2;

  if (!catalogueVersionToggle || (!force && !isSuperUser)) return null;

  return (
    <Button variant="contained" style={componentStyle} onClick={toggleVersion}>
      <img style={{ marginRight: "0.75rem" }} src={CatalogueIconOutline} className="appkiticon" alt="" />
      {isNewCatalogue ? `Back to legacy Catalogue` : `Try new Catalogue`}
    </Button>
  );
}
